var _require = require('chevrotain'),
    createToken = _require.createToken,
    Lexer = _require.Lexer; // the vocabulary will be exported and used in the Parser definition.


var tokenVocabulary = {};
var WhiteSpace = createToken({
  name: 'WhiteSpace',
  pattern: /\s+/,
  group: Lexer.SKIPPED
});
var String = createToken({
  name: 'String',
  pattern: /"(""|[^"])*"/
});
var SingleQuotedString = createToken({
  name: 'SingleQuotedString',
  pattern: /'(''|[^'])*'/
});
var SheetQuoted = createToken({
  name: 'SheetQuoted',
  pattern: /'((?![\\\/\[\]*?:]).)+?'!/
});
var Function = createToken({
  name: 'Function',
  pattern: /[A-Za-z_]+[A-Za-z_0-9.]*\(/
});
var ExcelRefFunction = createToken({
  name: 'ExcelRefFunction',
  pattern: /(INDEX|OFFSET|INDIRECT)\(/i
});
var ExcelConditionalRefFunction = createToken({
  name: 'ExcelConditionalRefFunction',
  pattern: /(IF|CHOOSE)\(/i
});
var FormulaErrorT = createToken({
  name: 'FormulaErrorT',
  pattern: /#NULL!|#DIV\/0!|#VALUE!|#NAME\?|#NUM!|#N\/A/
});
var RefError = createToken({
  name: 'RefError',
  pattern: /#REF!/
});
var Name = createToken({
  name: 'Name',
  pattern: /[a-zA-Z_][a-zA-Z0-9_.?]*/ // longer_alt: RangeColumn // e.g. A:AA

});
var Sheet = createToken({
  name: 'Sheet',
  pattern: /[A-Za-z_.\d\u007F-\uFFFF]+!/
});
var Cell = createToken({
  name: 'Cell',
  pattern: /[$]?[A-Za-z]{1,3}[$]?[1-9][0-9]*/,
  longer_alt: Name
});
var ReservedName = createToken({
  name: 'ReservedName',
  pattern: /_xlnm\.[a-zA-Z_]+/
});
var Number = createToken({
  name: 'Number',
  pattern: /[0-9]+[.]?[0-9]*([eE][+\-][0-9]+)?/
});
var Boolean = createToken({
  name: 'Boolean',
  pattern: /TRUE|FALSE/i
});
var Column = createToken({
  name: 'Column',
  pattern: /[$]?[A-Za-z]{1,3}/,
  longer_alt: Name
});
/**
 * Symbols and operators
 */

var At = createToken({
  name: 'At',
  pattern: /@/
});
var Comma = createToken({
  name: 'Comma',
  pattern: /,/
});
var Colon = createToken({
  name: 'Colon',
  pattern: /:/
});
var Semicolon = createToken({
  name: 'Semicolon',
  pattern: /;/
});
var OpenParen = createToken({
  name: 'OpenParen',
  pattern: /\(/
});
var CloseParen = createToken({
  name: 'CloseParen',
  pattern: /\)/
});
var OpenSquareParen = createToken({
  name: 'OpenSquareParen',
  pattern: /\[/
});
var CloseSquareParen = createToken({
  name: 'CloseSquareParen',
  pattern: /]/
});
var ExclamationMark = createToken({
  name: 'exclamationMark',
  pattern: /!/
});
var OpenCurlyParen = createToken({
  name: 'OpenCurlyParen',
  pattern: /{/
});
var CloseCurlyParen = createToken({
  name: 'CloseCurlyParen',
  pattern: /}/
});
var QuoteS = createToken({
  name: 'QuoteS',
  pattern: /'/
});
var MulOp = createToken({
  name: 'MulOp',
  pattern: /\*/
});
var PlusOp = createToken({
  name: 'PlusOp',
  pattern: /\+/
});
var DivOp = createToken({
  name: 'DivOp',
  pattern: /\//
});
var MinOp = createToken({
  name: 'MinOp',
  pattern: /-/
});
var ConcatOp = createToken({
  name: 'ConcatOp',
  pattern: /&/
});
var ExOp = createToken({
  name: 'ExOp',
  pattern: /\^/
});
var PercentOp = createToken({
  name: 'PercentOp',
  pattern: /%/
});
var GtOp = createToken({
  name: 'GtOp',
  pattern: />/
});
var EqOp = createToken({
  name: 'EqOp',
  pattern: /=/
});
var LtOp = createToken({
  name: 'LtOp',
  pattern: /</
});
var NeqOp = createToken({
  name: 'NeqOp',
  pattern: /<>/
});
var GteOp = createToken({
  name: 'GteOp',
  pattern: />=/
});
var LteOp = createToken({
  name: 'LteOp',
  pattern: /<=/
}); // The order of tokens is important

var allTokens = [WhiteSpace, String, SheetQuoted, SingleQuotedString, ExcelRefFunction, ExcelConditionalRefFunction, Function, FormulaErrorT, RefError, Sheet, Cell, Boolean, Column, Name, ReservedName, Number, At, Comma, Colon, Semicolon, OpenParen, CloseParen, OpenSquareParen, CloseSquareParen, // ExclamationMark,
OpenCurlyParen, CloseCurlyParen, QuoteS, MulOp, PlusOp, DivOp, MinOp, ConcatOp, ExOp, MulOp, PercentOp, NeqOp, GteOp, LteOp, GtOp, EqOp, LtOp];
var SelectLexer = new Lexer(allTokens, {
  ensureOptimizations: true
});
allTokens.forEach(function (tokenType) {
  tokenVocabulary[tokenType.name] = tokenType;
});
module.exports = {
  tokenVocabulary: tokenVocabulary,
  lex: function lex(inputText) {
    var lexingResult = SelectLexer.tokenize(inputText);

    if (lexingResult.errors.length > 0) {
      var error = lexingResult.errors[0];
      var line = error.line,
          column = error.column;
      var msg = '\n' + inputText.split('\n')[line - 1] + '\n';
      msg += Array(column - 1).fill(' ').join('') + '^\n';
      error.message = msg + "Error at position ".concat(line, ":").concat(column, "\n") + error.message;
      throw Error(error.message);
    }

    return lexingResult;
  }
};